import { render, staticRenderFns } from "./PaperContentSettings.vue?vue&type=template&id=08ce061a&scoped=true&"
import script from "./PaperContentSettings.vue?vue&type=script&lang=js&"
export * from "./PaperContentSettings.vue?vue&type=script&lang=js&"
import style0 from "./PaperContentSettings.vue?vue&type=style&index=0&id=08ce061a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ce061a",
  null
  
)

export default component.exports